import React from 'react';

export const ScrollingContainerRefContext =
  React.createContext<React.MutableRefObject<HTMLElement>>(null);
